'use strict';

controller.$inject = ["$element", "$timeout"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.template = undefined;
exports.controller = controller;

require('project/thumbnail');

require('site/heading');

require('site/menu');

var _scroll = require('scroll');

var scroll = _interopRequireWildcard(_scroll);

var _specialGuest = require('special-guest.scss');

var styles = _interopRequireWildcard(_specialGuest);

var _logo = require('assets/logo.svg');

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var template = exports.template = '\n<site-menu ng-if="ctrl.menuVisible" class="' + styles.menu + '" on-close="ctrl.toggleMenu(false)" on-selection="ctrl.showSection(section)"></site-menu>\n<a href="" ng-click="ctrl.toggleMenu()" class="' + styles.logo + '">' + _logo2.default + '</a>\n<section name="project_list" class="' + styles.project_list + '">\n  <project-thumbnail name="project_thumb" class="' + styles.project + '" ng-repeat="project in ctrl.projects" project="project"></project-thumbnail>\n</section>\n<site-heading name="heading" class="' + styles.heading + '" title="ctrl.heading.title" body="ctrl.heading.body"></site-heading>\n';

var projects = [{
  partner: 'SQUARESPACE',
  title: 'BUILD IT BEAUTIFUL',
  description: 'OUR CREATIVE PARTNERSHIP WITH SQUARESPACE',
  img: 'assets/squarespace.jpg'
}, {
  partner: 'QUALCOMM',
  title: 'INVENTOR LAB',
  description: 'A COLLABORATION WITH INVENTORS AND QUALCOMM',
  img: 'assets/qualcomm.jpg'
}, {
  partner: 'ARLE AGRO',
  title: 'FROOTI',
  description: 'A CREATIVE PARTNERSHIP WITH SAGMEISTER & WALSH',
  img: 'assets/frooti.jpg'
}, {
  partner: 'ARLE AGRO',
  title: 'FROOTI',
  description: 'A CREATIVE PARTNERSHIP WITH SAGMEISTER & WALSH',
  img: 'assets/frooti.jpg'
}];

var heading = {
  title: 'WE ARE',
  body: 'HYBRID THINKERS AND HYPER MAKERS'
};

function controller($element, $timeout) {
  this.deps = { $element: $element, $timeout: $timeout };
  this.projects = projects;
  this.heading = heading;
  this.menuVisible = false;
}

controller.prototype = {
  $postLink: function $postLink() {
    var el = this.deps.$element[0];
    this.deps.$timeout(function () {
      return scroll.init(el);
    });
  },
  toggleGrid: function toggleGrid() {
    angular.element(document.body).toggleClass('grid');
  },
  showSection: function showSection(section) {
    this.heading.body = section + ' SECTION WAS SELECTED';
    this.toggleMenu(false);
  },
  toggleMenu: function toggleMenu(visible) {
    if (typeof visible !== 'undefined') {
      this.menuVisible = visible;
    } else {
      this.menuVisible = !this.menuVisible;
    }
  }
};

var $directive = {
  scope: {},
  transclude: true
};

if(typeof bindings !== 'undefined') { $directive.bindToController = bindings }

angular.extend($directive, module.exports);

$directive.compile = function($element) {
  if(styles && styles.component) {
    $element.addClass(styles.component)
  }
  if(typeof(compile) === 'function') {
    return compile.apply(this, Array.prototype.slice.call(arguments));
  } else if(typeof(link) === 'function') {
    return {post: link};
  }
};

var $module = require('utils/module-registry').getModule('special-guest');

if (controller) {
  $directive.controller = 'specialGuestCtrl as ctrl';
  $module.controller('specialGuestCtrl', controller);
}

$module.directive('specialGuest', function() { return $directive });


/*****************
 ** WEBPACK FOOTER
 ** ./special-guest.directive.js
 ** module id = 32
 ** module chunks = 0
 **/